import { ctxReport } from '@/contexts/ReportCtx';
import { ReportTabValue } from '@/types';
import { useContext } from 'react';
import CategorySelector from './CategorySelector';
import { ReportTabs } from './ReportPopup';
import ReportDriverSelector from './ReportDriverSelector';
import ReportTargetSelector from './ReportTargetSelector';
import { ReportData } from './ReportData';
import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';
import Box from '@mui/material/Box';
import { JSX } from 'react';

export function ReportMobileBody({
  activeTab,
  setActiveTab,
}: {
  activeTab: ReportTabs;
  setActiveTab: (tab: ReportTabs) => void;
}) {
  const reportCtx = useContext(ctxReport);

  if (!reportCtx) return;

  function setSelectedDatesWrapper(from: Date, to: Date) {
    reportCtx?.setSelectedDates({ from, to });
    reportCtx?.setTab(ReportTabValue.categorySelect);
  }

  switch (reportCtx?.tab) {
    case ReportTabValue.dateSelect:
      return <StaticDateRangeSelect setSelectedDates={setSelectedDatesWrapper} />;
    case ReportTabValue.categorySelect:
      return <CategorySelector activeTab={activeTab} setActiveTab={setActiveTab} isPhone={true} />;
    case ReportTabValue.result:
      return <ReportData isListView={true} />;
    case ReportTabValue.entitySelect: {
      const selectors: Record<string, JSX.Element> = {
        TargetTab: <ReportTargetSelector />,
        DriverTab: <ReportDriverSelector />,
      };

      return <Box className="selector-box">{selectors[activeTab]}</Box>;
    }
  }
}
